import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_JWT_SECRET;

/**
 * Criptografa uma string usando AES
 * @param {string} text - Texto para criptografar
 * @returns {string} - Texto criptografado
 */
export const encrypt = (text) => {
  try {
    if (!text) {
      throw new Error('Texto para criptografar não pode ser vazio');
    }

    const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY);
    return encrypted.toString();
  } catch (error) {
    console.error('Erro ao criptografar:', error);
    throw error;
  }
};

/**
 * Descriptografa uma string criptografada
 * @param {string} encryptedText - Texto criptografado
 * @returns {string} - Texto descriptografado
 */
export const decrypt = (encryptedText) => {
  try {
    if (!encryptedText) {
      return '';
    }

    const decrypted = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY);
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Erro ao descriptografar:', error);
    throw error;
  }
};